var styleDataHash = "ccf2f785";
const injectCss = () => {
  var css = `@charset "UTF-8";._53c39,.glob_fontElementMap{font-family:var(--ricos-font-family,unset)}._1o3OZ{align-items:center;color:var(--ricos-internal-toolbar-button-text-color,#000);display:flex;font-family:var(--ricos-settings-text-font-family,Madefor,"Helvetica Neue",Helvetica,Arial,メイリオ,meiryo,"ヒラギノ角ゴ pro w3","hiragino kaku gothic pro",sans-serif);font-size:14px;gap:3px;height:30px;justify-content:center;min-width:30px}[dir] ._1o3OZ{background:transparent;border:transparent;border-radius:var(--ricos-internal-toolbar-button-border-radius,6px);cursor:pointer;margin:0}._1o3OZ:hover:not([disabled]){color:var(--ricos-internal-toolbar-button-text-color-hover,#116dff)}[dir] ._1o3OZ:hover:not([disabled]){background-color:var(--ricos-internal-toolbar-button-background-color-hover,#e7f0ff)}._1o3OZ.NGTt-{color:var(--ricos-settings-text-color,var(--ricos-action-color-fallback,#116dff));fill:var(--ricos-settings-text-color,var(--ricos-action-color-fallback,#116dff))}[dir] ._1o3OZ.NGTt-{background-color:var(--ricos-internal-toolbar-button-background-color-active,#d6e6fe)}._1o3OZ.NGTt- svg{fill:var(--ricos-settings-icons-color,currentColor);color:var(--ricos-settings-icons-color,currentColor)}._1o3OZ._8nRU5{opacity:.4;pointer-events:none}[dir] ._1o3OZ._8nRU5{cursor:default}[dir] ._1o3OZ.t1whR:not(.NGTt-):hover{background-color:unset}._1o3OZ.t1whR{height:36px;min-width:36px}._1o3OZ:focus{outline:5px auto Highlight!important;outline:5px auto -webkit-focus-ring-color!important}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var toolbar_button_default = {
  "fontElementMap": "_53c39",
  "toolbarButton": "_1o3OZ",
  "active": "NGTt-",
  "disabled": "_8nRU5",
  "mobileToolbarButton": "t1whR"
};
export {
  toolbar_button_default as default,
  injectCss
};
//# sourceMappingURL=toolbar-button-scss.js.map
